import { APIMethod, fetchData } from "@client";

export async function updatePaymentMethodQuery(paymentMethodId) {
  return await fetchData("/company/payment/default", APIMethod.PUT, {
    data: { paymentMethodId },
    mapRequestKeysToSnakeCase: false
  });
}
